import axios from "axios";

let Api = axios.create({
  baseURL: "https://api.carnescruvi.com.mx/api/spa",
  // baseURL: "http://192.168.1.65:8080/api/spa",
  // baseURL: ~ "https://movil-api.carnescruvi.com/api/spa" ~,
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    },
    post: {
      "Content-Type": "application/json"
    }
  }
});

Api.defaults.withCredentials = true;

/**
 * Revisando API de https://github.com/axios/axios#interceptors
 *
 * Cachando las respuestas de Error
 */

Api.interceptors.response.use(
  response => response,
  function(error) {
    if (401 === error.response.status) {
      console.log("Cachando el error 401");
      console.log(error);
      localStorage.clear();
      alert("Su sesión ha expirado");
      window.location = "/login";
    } else {
      return Promise.reject(error);
    }
  }
);

/*
 * Agregando token Bearer
 */
Api.interceptors.request.use(function(config) {
  const token = localStorage.getItem("token");
  if (token != null) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

window.Api = Api;

export default Api;
